import React from 'react';
import PropTypes from 'prop-types';
import { FormError, WaterZipForm } from 'components/Forms';

const FormsMapper = ({ type }) => {
  switch (type) {
    case 'waterZip':
      return <WaterZipForm view="block" />;
    case 'formError':
      return <FormError />;
    default:
      return null;
  }
};

FormsMapper.propTypes = {
  type: PropTypes.string.isRequired,
};

export default FormsMapper;
